import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  AdminBoundaryImportTriggerResponseSchema,
  AdminBoundaryImportStatusSchema,
  AdminBoundaryBboxQuerySchema,
  AdminBoundaryFeatureCollectionSchema,
} from '../schemas/admin-boundaries.js';

export const adminBoundaries = {
  /**
   * GET /admin-boundaries/geojson
   *
   * Authenticated bbox-scoped endpoint for reading selectable administrative-
   * area (e.g. Warsaw district) geometry intersecting the given viewport.
   * Returns a GeoJSON FeatureCollection (empty when no area intersects).
   *
   * Query params: minLon, minLat, maxLon, maxLat — bbox corners (coerced from string).
   */
  listGeoJson: endpoint(
    'GET',
    '/admin-boundaries/geojson',
    AdminBoundaryBboxQuerySchema,
    AdminBoundaryFeatureCollectionSchema,
  ),
  /**
   * POST /admin-boundaries/import
   *
   * Admin-only endpoint that enqueues a one-off administrative-boundary import
   * job. The job calls the idempotent `seedAdminBoundaries` from `@ooh/db`.
   * Returns 202 Accepted with the enqueued job ID.
   * Returns 409 Conflict when a job is already active in the queue.
   */
  triggerImport: endpoint(
    'POST',
    '/admin-boundaries/import',
    z.object({}),
    AdminBoundaryImportTriggerResponseSchema,
  ),

  /**
   * GET /admin-boundaries/import/status
   *
   * Admin-only endpoint returning the current administrative-boundary import
   * job state derived from the BullMQ queue.
   */
  importStatus: endpoint(
    'GET',
    '/admin-boundaries/import/status',
    z.object({}),
    AdminBoundaryImportStatusSchema,
  ),
};
